// utils/resolveAvvyName.ts
import  AVVY  from '@avvy/client';
export const resolveAvvyName = async (address, provider) => {
  try {
    const avvy = new AVVY(provider);
    const hash = await avvy.reverse(AVVY.RECORDS.EVM, address);

    if (hash) {
      const result = await hash.lookup();
      return result.name;
    }
  } catch (err) {
    console.error("AVVY reverse lookup error:", err);
  }
  return null;
};
